// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2isBw","content":"GlobalSearch_content__6QwpN"};